

import { mapActions } from "vuex";
import { isCNPJ, isCPF } from "vuetify-masks-br";
import axios from "axios";
import paginationComponent from "../../components/paginationComponent";
import DataComponent from "../../components/DataComponent";
import helper from "../../mixins/helper";

export default {
  components: { paginationComponent, DataComponent },

  data: () => ({
    /** Limite superior para emissão e vencimento (dívidas vencidas: sem data futura). ISO yyyy-MM-dd. */
    dataHoje: null,
    /** Remonta o subform da dívida para alinhar v-model, datas e validação após salvar/editar. */
    dividaFormKey: 0,
    mixins: [helper],
    ldg_enviar: false,
    qtTelefone: 1,
    qtEmail: 1,
    ca_endereco: '',
    dialogCoautor: false,
    coautores: [],
    coautorEditForm: {
      name: "",
      data_nascimento: null,
      cpf_cnpj: "",

      rg: "",
      endereco: "",
      bairro: "",
      numero: "",
      municipio: "",
      uf: "",
      cep: "",
      cepConvertido: "",
      telefone: "",
      telefone2: "",
      telefone3: "",
      email: "",
      email2: "",
      email3: "",
      observacao: "",
      user_juridica: false
    },
    alertar: false,
    dialog: false,
    lote: false,
    isArquivo: false,
    column: null,
    isDisabled: false,
    loading: false,
    pagination: [],
    ufs: [
      'RO', 'AC', 'AM', 'RR', 'PA', 'AP', 'TO', 'MA', 'PI', 'CE', 'RN', 'PB', 'PE', 'AL', 'SE', 'BA', 'MG', 'ES', 'RJ', 'SP', 'PR', 'SC', 'RS', 'MS', 'MT', 'GO', 'DF'],
    list: [],
    csv: [],
    linhas: [],
    isTable: false,
    isSend: false,
    row: "cpf",
    row2: "cpf",
    items: [],
    menu: false,
    isDownload: false,
    anexo_lote: null,
    arquivo_lote: null,
    dividas: [],
    /** Lote da inclusão em andamento (devolvido pelo 1º título; os seguintes vão nele). */
    loteAtual: null,
    showCoautores: false,
    form: {
      devedor: {
        name: "",
        data_nascimento: null,
        cpf_cnpj: "",

        rg: "",
        endereco: "",
        bairro: "",
        numero: "",
        municipio: "",
        uf: "",
        cep: "",
        cepConvertido: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        email: "",
        email2: "",
        email3: "",
        observacao: "",
        user_juridica: false,
      },
      divida: {
        numero_titulo: null,
        nosso_numero: null,
        especie: null,
        valor_original: null,
        valor_vencido: null,
        data_emissao: "",
        data_vencimento: "",
        observacao: "",
        file: null,
      },
    },
    emailRule: [
      (v) => !!v || "E-mail é obrigatória",
      (v) => /.+@.+\..+/.test(v) || "insira um email E-mail válido",
    ],
    cpfRule: [
      (v) => !!v || "CPF é obrigatória",
      (v) => isCPF(v || "") || "CPF não é válido.",
    ],
    cnpjRule: [
      (v) => !!v || "CNPJ é obrigatória",
      (v) => isCNPJ(v || "") || "CNPJ não é válido.",
    ],
  }),

  created() {
    /* window.addEventListener('beforeunload', function(event) {
        event.returnValue = 'Write something'
     })*/
  },


  /* beforeWindowUnload (to, from, next) {
     // If the form is dirty and the user did not confirm leave,
     // prevent losing unsaved changes by canceling navigation
  
     if(this.confirmLeave()){
     next(true)
     }else{
       return false;
     }
    
     if (this.confirmStayInDirtyForm()){
       next(false)
     } else {
       // Navigate to next view
       return false;
     }
   },
   beforeRouteLeave (to, from, next) {
     // If the form is dirty and the user did not confirm leave,
     // prevent losing unsaved changes by canceling navigation
 
     if(this.confirmLeave()){
     next(true)
     }else{
       return false;
     }
    
     if (this.confirmStayInDirtyForm()){
       next(false)
     } else {
       // Navigate to next view
       return false;
     }
   },*/

  mounted() {
    /*this.notificacao(
      "Atenção",
      "Preencha todos os campos obrigatórios!",
      "error"
    );*/

    this.getEspecies()

    this.dataHoje = new Date().toISOString().split('T')[0]

    const empresas = this.$store.state.auth.user.empresas
    if (Array.isArray(empresas) && empresas.length <= 0) {
      this.alertar = true
    }
  },
  methods: {
    ...mapActions("auth", ["enviarDividaFile", "ActionSendDividaLote"]),
    filtroTeclas(event) {

      this.form.devedor.cpf_cnpj = ('0123456789'.search(event.key) > 0);

    },

    confirmLeave() {

      //  return window.confirm('Você deseja mesmo sair e perder todos os dados?')
    },



    confirmStayInDirtyForm() {

      return this.form_dirty && !this.confirmLeave()
    },

    beforeWindowUnload(e) {

      if (this.confirmStayInDirtyForm()) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    },
    removerNumero() {
      if (this.qtTelefone == 3) {
        this.qtTelefone = 2;
        this.form.devedor.telefone3 = "";
        return null
      }
      if (this.qtTelefone == 2) {
        this.qtTelefone = 1;
        this.form.devedor.telefone2 = "";
        return null
      }

    },
    removerMail() {
      if (this.qtEmail == 3) {
        this.qtEmail = 2;
        this.form.devedor.email3 = "";
        return null
      }
      if (this.qtEmail == 2) {
        this.qtEmail = 1;
        this.form.devedor.email2 = "";
        return null
      }

    },
    getEspecies() {
      this.$http.get("getEspecies").then(
        (response) => {
          this.items = response.data
          console.log(this.itens)
        },
        (response) => {
          console.log(response);
        }
      );
    },
    CadastrarEmpresa() {
      this.$router.push({ name: "empresas" });
    },
    dividaVazia() {
      return {
        numero_titulo: null, nosso_numero: null, especie: null,
        valor_original: null, valor_vencido: null,
        data_emissao: '', data_vencimento: '', observacao: '', file: null,
      };
    },
    dividaCamposObrigatoriosFaltando(d) {
      const faltas = [];
      const preenchido = (v) => v !== null && v !== undefined && String(v).trim() !== '';
      const dataValida = (v) => {
        if (v === null || v === undefined) return false;
        const s = String(v).trim();
        if (s === '' || s === 'null' || s === 'undefined') return false;
        return true;
      };
      const valorOriginalOk = (v) => {
        if (v === null || v === undefined || v === '') return false;
        const n = Number(v);
        return !Number.isNaN(n);
      };
      if (!preenchido(d.numero_titulo)) faltas.push('Número do título');
      if (!preenchido(d.nosso_numero)) faltas.push('Nosso número');
      if (d.especie === null || d.especie === undefined || d.especie === '') faltas.push('Espécie');
      if (!valorOriginalOk(d.valor_original)) faltas.push('Valor original');
      if (!dataValida(d.data_emissao)) faltas.push('Data de emissão');
      if (!dataValida(d.data_vencimento)) faltas.push('Data de vencimento');
      return faltas;
    },
    adicionarDivida() {
      const d = this.form.divida;
      const faltas = this.dividaCamposObrigatoriosFaltando(d);
      if (faltas.length) {
        return this.notificacao(
          'Atenção',
          `Preencha: ${faltas.join(', ')}.`,
          'error'
        );
      }
      this.dividas.push({ ...d });
      this.form.divida = this.dividaVazia();
      this.dividaFormKey += 1;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.divForm) this.$refs.divForm.resetValidation();
        });
      });
    },
    editarDivida(index) {
      this.form.divida = { ...this.dividas[index] };
      this.dividas.splice(index, 1);
      this.dividaFormKey += 1;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.divForm) this.$refs.divForm.resetValidation();
        });
      });
    },
    removerDivida(index) {
      this.dividas.splice(index, 1);
    },
    excluirCoautor(id) {

      this.coautores.splice(id, 1);

    },
    fecharCoautor() {
      this.dialogCoautor = false;
      this.coautorEditForm = [];

    },
    salvarCoautor() {
      /*
    alert( (this.coautorEditForm.name??'').length  )
    alert(  (this.coautorEditForm.cpf_cnpj??'').length)
    alert(  (this.coautorEditForm.endereco??'').length)
    alert(  (this.coautorEditForm.bairro??'').length)
    alert(  (this.coautorEditForm.numero??'').length)
    alert(  (this.coautorEditForm.municipio??'').length)
    alert(  (this.coautorEditForm.cep??'').length)
    alert(  (this.coautorEditForm.telefone??'').length)
    alert(  (this.coautorEditForm.email??'').length)*/


      if (
        (this.coautorEditForm.name ?? '').length > 3 &&
        (this.coautorEditForm.cpf_cnpj ?? '').length > 3 &&
        (this.coautorEditForm.endereco ?? '').length > 3 &&
        (this.coautorEditForm.bairro ?? '').length > 3 &&
        (this.coautorEditForm.numero ?? '').length > 0 &&
        (this.coautorEditForm.municipio ?? '').length > 3 &&
        (this.coautorEditForm.cep ?? '').length > 3 &&
        (this.coautorEditForm.telefone ?? '').length > 1 &&
        (this.coautorEditForm.email ?? '').length > 3
      ) {
        if (typeof this.coautorEditForm.id !== 'undefined') {
          this.coautores[this.coautorEditForm.id] = this.coautorEditForm;
          this.dialogCoautor = false;
        } else {
          console.log(this.coautorEditForm);
          this.coautores.push(this.coautorEditForm);
          this.dialogCoautor = false;

        }
        this.coautorEditForm = {};

      } else {
        return this.notificacao("Campos obrigatórios não preechidos", 'Gentileza verificar os dados informados para prossegui com o cadastro', "error");
      }



    },
    formCoautor(id) {
      this.inicializarCoAutor();
      if (id == -1) {
        console.log(id)
        this.dialogCoautor = true;
        // this.coautorEditForm = [];
      } else {
        this.coautorEditForm = this.coautores[id];
        this.coautorEditForm.id = id;
        this.dialogCoautor = true;
      }
    },
    home() {
      this.$router.push({ name: "home" });
    },
    loteOpen() {
      this.lote = true;
    },
    coautoresSerialize() {
      var coautoreArray = [];

      this.coautores.map(function (item) {
        coautoreArray.push({
          name: item.name,
          bairro: item.bairro,
          cep: item.cep,
          email: item.email,
          email2: item.email2,
          email3: item.email3,
          endereco: item.endereco,
          numero: item.numero,
          municipio: item.municipio,
          cpf_cnpj: item.cpf_cnpj,
          rg: item.rg,
          observacao: item.observacao,
          telefone: item.telefone,
          uf: item.uf,
        })

      })

      return coautoreArray;
    },
    async enviarCoAutor(dividaID) {
      //const tempCoautores = this.coautores;
      var teste_coautores = this.coautoresSerialize();
      //alert( this.coautores )


      try {
        const { data: result } = await this.$http.post(
          `enviarDividaFile/${dividaID}/coautores`,
          {
            coautores: teste_coautores
          }
        );
        console.log(result);

        //console.log(result);
      } catch (error) {
        //
      } finally {
        //
      }

    },
    async EnviarDivida() {
      const coAutores = this.coautoresSerialize();

      if (!this.$refs.form.validate()) {
        return this.notificacao("Atenção", "Preencha todos os campos obrigatórios!", "error");
      }

      const faltasDivida = this.dividaCamposObrigatoriosFaltando(this.form.divida);
      if (faltasDivida.length) {
        return this.notificacao('Atenção', `Dados da dívida: preencha ${faltasDivida.join(', ')}.`, 'error');
      }

      // Junta as dívidas salvas + a atual preenchida no form
      const todasDividas = [...this.dividas, { ...this.form.divida }];

      const formDataArray = todasDividas.map(divida => {
        const fd = new FormData();
        fd.append("devedor['name']", this.form.devedor.name);
        fd.append("devedor['cpf_cnpj']", this.form.devedor.cpf_cnpj);
        fd.append("devedor['data_nascimento']", this.form.devedor.data_nascimento);
        fd.append("devedor['rg']", this.form.devedor.rg);
        fd.append("devedor['endereco']", this.form.devedor.endereco);
        fd.append("devedor['bairro']", this.form.devedor.bairro);
        fd.append("devedor['numero']", this.form.devedor.numero);
        fd.append("devedor['municipio']", this.form.devedor.municipio);
        fd.append("devedor['uf']", this.form.devedor.uf);
        fd.append("coautores", coAutores);
        fd.append("devedor['cep']", this.form.devedor.cep.replace(/([^\d])+/gim, ""));
        fd.append("devedor['telefone']", this.form.devedor.telefone.replace(/([^\d])+/gim, ""));
        fd.append("devedor['telefone2']", this.form.devedor.telefone2.replace(/([^\d])+/gim, ""));
        fd.append("devedor['telefone3']", this.form.devedor.telefone3.replace(/([^\d])+/gim, ""));
        fd.append("devedor['email']", this.form.devedor.email);
        fd.append("devedor['email2']", this.form.devedor.email2);
        fd.append("devedor['email3']", this.form.devedor.email3);
        fd.append("devedor['observacao']", this.form.devedor.observacao);
        fd.append("devedor['user_juridica']", this.form.devedor.user_juridica);
        fd.append("divida['numero_titulo']", divida.numero_titulo);
        fd.append("divida['nosso_numero']", divida.nosso_numero);
        fd.append("divida['especie']", divida.especie);
        fd.append("divida['valor_original']", divida.valor_original);
        fd.append("divida['valor_vencido']", divida.valor_vencido);
        fd.append("divida['data_emissao']", divida.data_emissao);
        fd.append("divida['data_vencimento']", divida.data_vencimento);
        fd.append("divida['observacao']", divida.observacao);
        fd.append("divida['file']", divida.file);
        return fd;
      });

      await this.enviarTodasDividas(formDataArray);
    },

    sendArquivos(formdata, jaEnviadas = 0) {
      return this.$http.post('enviarDividaFile', formdata).then(
        (response) => {
          this.enviarCoAutor(response.data.divida_id);
          return response.data;
        },
        (response) => {
          const motivo = response.data
            ? (typeof response.data === 'string' ? response.data : response.data.message || '')
            : '';
          // Os títulos anteriores já foram gravados: tira da lista para o reenvio não duplicar
          const aviso = jaEnviadas > 0
            ? ` ${jaEnviadas} ${jaEnviadas === 1 ? 'título anterior já foi gravado' : 'títulos anteriores já foram gravados'} e ${jaEnviadas === 1 ? 'saiu' : 'saíram'} da lista; corrija este e envie de novo (entra no mesmo lote).`
            : '';
          this.dividas.splice(0, Math.min(jaEnviadas, this.dividas.length));
          this.$swal({
            icon: 'error',
            customClass: { confirmButton: "btn btn-success", cancelButton: "btn btn-danger" },
            buttonsStyling: false,
            title: "Não foi possível completar registro",
            text: motivo + aviso,
            confirmButtonColor: '#8CD4F5',
          });
          this.ldg_enviar = false;
          throw new Error('send_error');
        }
      );
    },

    async enviarTodasDividas(formDataArray) {
      // Todos os títulos desta inclusão vão no mesmo lote: o 1º cria, os demais reaproveitam
      let enviadas = 0;
      for (const fd of formDataArray) {
        if (this.loteAtual) fd.append("lote", this.loteAtual);
        const resultado = await this.sendArquivos(fd, enviadas);
        if (resultado && resultado.lote) this.loteAtual = resultado.lote;
        enviadas++;
      }
      this.loteAtual = null;
      this.$swal({
        icon: 'success',
        customClass: { confirmButton: "btn btn-success" },
        buttonsStyling: false,
        title: "Negativação enviada com sucesso",
      });
      this.ldg_enviar = false;
      this.$router.push({ name: "Consulta de Títulos" });
    },
    inicializarCoAutor() {
      this.coautorEditForm =
      {
        name: "",
        data_nascimento: null,
        cpf_cnpj: "",

        rg: "",
        endereco: "",
        bairro: "",
        numero: "",
        municipio: "",
        uf: "",
        cep: "",
        cepConvertido: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        email: "",
        email2: "",
        email3: "",
        observacao: "",
        user_juridica: false
      }

    },
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: title,
        text: msg,
      });
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    getNascimento(data) {
      this.form.devedor.data_nascimento = data
    },
    getEmissao(data) {
      this.form.divida.data_emissao = data
    },

    async setarEnderecoCep(res) {
      var vm = this.coautorEditForm;
      console.log(vm)
      vm.municipio = res.data.localidade;
      vm.uf = res.data.uf;
      vm.bairro = res.data.bairro;
      vm.endereco = res.data.logradouro;


    },
    getVencimento(data) {

      this.form.divida.data_vencimento = data


    }


  },

  watch: {
    "form.devedor.cep": function (newValue) {
      var vm = this.form.devedor;
      var values = this;
      var local = newValue.replace(/([^\d])+/gim, "");

      if (local.length == 8) {
        axios
          .get("https://viacep.com.br/ws/" + local + "/json/")
          .then(function (res) {
            if (!res.data.erro) {
              vm.municipio = res.data.localidade;
              vm.uf = res.data.uf;
              vm.bairro = res.data.bairro;
              vm.endereco = res.data.logradouro;
            } else {
              values.$swal({
                toast: true,
                position: "center-end",
                showConfirmButton: false,
                background: "#ff0000",
                timer: 3000,
                icon: "error",
                title: '<span style="color:#FFF">Desculpe</span>',
                html: '<span style="color:#FFF">CEP não encontrado</span>',
              });
            }
          })
          .catch(function (err) {
            err;
          });
      }
    },
    "coautorEditForm.cep": function (newValue) {

      var vm = this.coautorEditForm;
      var values = this;
      var local = newValue.replace(/([^\d])+/gim, "");

      if (local.length == 8) {

        axios
          .get("https://viacep.com.br/ws/" + local + "/json/")
          .then(async function (res) {
            console.log(res)
            if (!res.data.erro) {
              //await this.setarEnderecoCep(res);
              console.log(vm)
              vm.municipio = res.data.localidade;
              vm.uf = res.data.uf;
              vm.bairro = res.data.bairro;
              vm.endereco = res.data.logradouro;

              alert(this.coautorEditForm)

            } else {
              values.$swal({
                toast: true,
                position: "center-end",
                showConfirmButton: false,
                background: "#ff0000",
                timer: 3000,
                icon: "error",
                title: '<span style="color:#FFF">Desculpe</span>',
                html: '<span style="color:#FFF">CEP não encontrado</span>',
              });
            }
          })
          .catch(function (err) {
            err;
          });
      }


    },
    row: function (newValue) {
      if (newValue == "cpf") {
        this.form.devedor.user_juridica = false;
      } else {
        this.form.devedor.user_juridica = true;
      }
      this.form.devedor.cpf_cnpj = "";
      this.form.devedor.rg = "";
      this.form.devedor.data_nascimento = null;
      this.isDisabled = false;
      this.form.devedor.name = "";
      this.form.devedor.rg = "";
      this.form.devedor.endereco = "";
      this.form.devedor.bairro = "";
      this.form.devedor.numero = "";
      this.form.devedor.municipio = "";
      this.form.devedor.uf = "";
      this.form.devedor.cep = "";
      this.form.devedor.telefone = "";
      this.form.devedor.telefone2 = "";
      this.form.devedor.telefone3 = "";
      this.form.devedor.email = "";
      this.form.devedor.email2 = "";
      this.form.devedor.email3 = "";
      this.form.devedor.observacao = "";
    },
    row2: function (newValue) {
      if (newValue == "cpf") {
        this.coautorEditForm.user_juridica = false;
      } else {
        this.coautorEditForm.user_juridica = true;
      }
      this.coautorEditForm.cpf_cnpj = "";
      this.coautorEditForm.rg = "";
      this.coautorEditForm.data_nascimento = null;
      this.isDisabled = false;
      this.coautorEditForm.name = "";
      this.coautorEditForm.rg = "";
      this.coautorEditForm.endereco = "";
      this.coautorEditForm.bairro = "";
      this.coautorEditForm.numero = "";
      this.coautorEditForm.municipio = "";
      this.coautorEditForm.uf = "";
      this.coautorEditForm.cep = "";
      this.coautorEditForm.telefone = "";
      this.coautorEditForm.telefone2 = "";
      this.coautorEditForm.telefone3 = "";
      this.coautorEditForm.email = "";
      this.coautorEditForm.email2 = "";
      this.coautorEditForm.email3 = "";
      this.coautorEditForm.observacao = "";
    },
    "form.devedor.cpf_cnpj": function (newValue) {

      // newValue = newValue.replace(/([^\d])+/gim, "");


      var local = newValue.replace(/([^\d])+/gim, "");
      var vm = this;
      if (this.row == "cpf") {
        if (local.length == 11) {
          this.loading = true;
          this.$http.get("getUsuario/" + local).then(
            (response) => {
              // get body data
              if (response.data.erro != true) {

                vm.form.devedor.name = response.data.name;
                vm.form.devedor.cpf_cnpj; 1
                vm.isDisabled = true;
              }

              this.loading = false;
              // vm.form.devedor.data_nascimento = response.data.data_nascimento
            },
            (response) => {
              console.log(response);
              // error callback
            }
          );
        }
      } else {
        if (local.length == 14) {
          this.loading = true;
          this.$http.get(`buscarEmpresaReceita/${local}`).then(
            (response) => {
              console.log(response)
              vm.form.devedor.cpf_cnpj;
              vm.form.devedor.name = response.data.nome;
              vm.form.devedor.endereco = response.data.endereco;
              vm.form.devedor.bairro = response.data.bairro;
              vm.form.devedor.numero = response.data.numero;
              vm.form.devedor.municipio = response.data.municipio;
              vm.form.devedor.uf = response.data.uf;
              vm.form.devedor.cep = response.data.cep;
              vm.form.devedor.telefone = response.data.telefone;
              // vm.form.devedor.telefone2 = response.data.telefone2;
              //vm.form.devedor.telefone3 = response.data.telefone3;
              vm.form.devedor.email = response.data.email;
              //vm.form.devedor.email2 = response.data.email2;
              //vm.form.devedor.email3 = response.data.email3;
              vm.form.devedor.observacao = response.data.observacao;
              vm.isDisabled = true;
              this.loading = true;
            },
            (response) => {
              console.log(response);
              // error callback
            }
          );
        }
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }

  }
}